import React, { useMemo, useState, useEffect } from "react";

import { Link, useNavigate } from "react-router-dom";

import axios from "../../api/axios";
import EmailPresupuestoModal from "../EmailPresupuestoModal.jsx";






/* ============================
   UTILIDADES
============================ */
function ahoraStr() {
  // dd/mm/aaaa, hh:mm:ss (similar a tu app)
  return new Date().toLocaleString("es-ES");
}

function tieneLlamadaPendiente(visita) {
  if (visita.estado === "no_interesado" || visita.estado === "vendido") {
    return false;
  }
  return (visita.observaciones || []).some((o) => o.requiereLlamada);
}

function estadoPresupuestoLabel(estado) {
  if (estado === "aceptado") return "🟢 Aceptado";
  if (estado === "rechazado") return "🔴 Rechazado";
  return "🟡 Pendiente";
}

function formatFechaHora(fechaISO) {
  if (!fechaISO) return "";
  const d = new Date(fechaISO);
  return d.toLocaleString("es-ES", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
}






/* ============================
   COMPONENTE PRINCIPAL
============================ */
export default function CRM() {
  const [visitas, setVisitas] = useState([]);
const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [orden, setOrden] = useState("modificacion_desc");
  const [editandoId, setEditandoId] = useState(null);
  const [openEmail, setOpenEmail] = useState(false);
const [emailData, setEmailData] = useState(null);






useEffect(() => {
  cargarCRM();
}, []);

const cargarCRM = async () => {
  try {
    const r = await axios.get("/crm");
    setVisitas(r.data || []);
  } catch (err) {
    console.error("Error cargando CRM:", err);
  } finally {
    setLoading(false);
  }
};
const [filtros, setFiltros] = useState({
  ciudad: "",
  estado: "",
  llamadasPendientes: false
});




  // Expand/collapse por visita (tipo SAT)
const [expanded, setExpanded] = useState({});


  // Formulario NUEVA VISITA (arriba, como pantalla SAT con "añadir incidencia")
  const [mostrarNuevaVisita, setMostrarNuevaVisita] = useState(false);
  const [formNueva, setFormNueva] = useState({
  comercial: "",
  contacto: "",
  telefono: "",
  email: "",
  direccion: "",
  ciudad: ""
});


  // Formulario OBSERVACIÓN por visita (inline)
  const [obsDraft, setObsDraft] = useState({});

const visitasFiltradas = useMemo(() => {
  let resultado = visitas.filter((v) => {
    if (filtros.ciudad && v.ciudad !== filtros.ciudad) return false;
    if (filtros.estado && v.estado !== filtros.estado) return false;
    if (filtros.llamadasPendientes && !tieneLlamadaPendiente(v)) return false;
    return true;
  });

  resultado = [...resultado].sort((a, b) => {
    const createdA = new Date(a.createdAt);
    const createdB = new Date(b.createdAt);
    const updatedA = new Date(a.updatedAt || a.ultimaModificacion);
    const updatedB = new Date(b.updatedAt || b.ultimaModificacion);

    switch (orden) {
      case "creacion_asc":
        return createdA - createdB;
      case "creacion_desc":
        return createdB - createdA;
      case "modificacion_desc":
      default:
        return updatedB - updatedA;
    }
  });

  return resultado;
}, [visitas, filtros, orden]);





const setEstadoVisita = async (id, estado) => {
  try {
    // Guardar estado en backend
    await axios.put(`/crm/${id}/estado`, { estado });

    // Volver a cargar datos reales
    await cargarCRM();
  } catch (err) {
    console.error("Error guardando estado de visita:", err);
  }
};


/* ============================
   NUEVA VISITA
============================ */
const onGuardarNuevaVisita = async () => {
  try {
    if (editandoId) {
      await axios.put(`/crm/${editandoId}`, formNueva);
    } else {
      await axios.post("/crm", formNueva);
    }

    setMostrarNuevaVisita(false);
    setEditandoId(null);
    setFormNueva({
      comercial: "",
      contacto: "",
      telefono: "",
      email: "",
      direccion: "",
      ciudad: ""
    });

    await cargarCRM();
  } catch (err) {
    console.error("Error guardando visita CRM:", err);
  }
};



  /* ============================
     OBSERVACIONES INLINE
  ============================ */
  const onToggleExpanded = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const onChangeObsDraft = (id, patch) => {
    setObsDraft((prev) => ({ ...prev, [id]: { ...prev[id], ...patch } }));
  };

  const onAddObservacion = async (id) => {
  const draft = obsDraft[id] || {
    texto: "",
    fecha: "",
    hora: "",
    requiereLlamada: false
  };

  const texto = (draft.texto || "").trim();
  if (!texto) return;

  try {
    await axios.post(`/crm/${id}/observaciones`, {
      texto,
      fecha: draft.fecha || null,
      hora: draft.hora || null,
      requiereLlamada: !!draft.requiereLlamada
    });

    // Limpiar formulario
    setObsDraft((prev) => ({
      ...prev,
      [id]: { texto: "", fecha: "", hora: "", requiereLlamada: false }
    }));

    // Recargar desde backend (fuente de verdad)
    await cargarCRM();

    // Abrir bloque (UX tipo SAT)
    setExpanded((prev) => ({ ...prev, [id]: true }));
  } catch (err) {
    console.error("Error guardando observación:", err);
  }
};


  const onMarcarLlamadaHecha = (visitaId, obsIndex) => {
    const nuevas = visitas.map((v) => {
      if (v.id !== visitaId) return v;
      const obs = [...(v.observaciones || [])];
      if (!obs[obsIndex]) return v;

      obs[obsIndex] = { ...obs[obsIndex], requiereLlamada: false };
      return { ...v, ultimaModificacion: ahoraStr(), observaciones: obs };
    });

    setVisitas(nuevas);
  };

  return (
    <div style={page}>


      {/* CABECERA SAT-LIKE */}
      <div style={header}>
        <div>
          <h1 style={title}>CRM – Visitas comerciales</h1>
          <div style={subtitle}>
            Listado operativo tipo SAT (observaciones inline)
          </div>
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <button
            style={btnPrimary}
            onClick={() => setMostrarNuevaVisita((s) => !s)}
          >
            {mostrarNuevaVisita ? "✖ Cerrar" : "➕ Nueva visita"}
          </button>

          <button style={btnDisabled} disabled>
            🗺️ Mapa
          </button>

          <Link to="/dashboard" style={btnLink}>
            ⬅ Volver
          </Link>
        </div>
      </div>

{/* FILTROS COMPACTOS */}
<div style={filterBar}>
  {/* Filtro ciudad */}
  <select
    value={filtros.ciudad}
    onChange={(e) =>
      setFiltros((f) => ({ ...f, ciudad: e.target.value }))
    }
    style={filterSelectSmall}
  >
    <option value="" style={{ background: "#0f172a", color: "white" }}>
      Ciudad
    </option>
    {[...new Set(visitas.map((v) => v.ciudad).filter(Boolean))].map(
      (c) => (
        <option
          key={c}
          value={c}
          style={{ background: "#0f172a", color: "white" }}
        >
          {c}
        </option>
      )
    )}
  </select>

  {/* Filtro estado */}
  <select
    value={filtros.estado}
    onChange={(e) =>
      setFiltros((f) => ({ ...f, estado: e.target.value }))
    }
    style={filterSelectSmall}
  >
    <option value="" style={{ background: "#0f172a", color: "white" }}>
      Estado
    </option>
    <option value="visitado" style={{ background: "#0f172a", color: "white" }}>
      Visitado
    </option>
    <option value="interesado" style={{ background: "#0f172a", color: "white" }}>
      Interesado
    </option>
    <option value="no_interesado" style={{ background: "#0f172a", color: "white" }}>
      No interesado
    </option>
    <option value="vendido" style={{ background: "#0f172a", color: "white" }}>
      Vendido
    </option>
    
  </select>

  {/* Filtro llamadas */}
  <label style={filterCheck}>
    <input
      type="checkbox"
      checked={filtros.llamadasPendientes}
      onChange={(e) =>
        setFiltros((f) => ({
          ...f,
          llamadasPendientes: e.target.checked
        }))
      }
    />
    📞 Pendientes
  </label>

<select
  value={orden}
  onChange={(e) => setOrden(e.target.value)}
  style={filterSelectSmall}
>
  <option
    value="modificacion_desc"
    style={{ background: "#0f172a", color: "white" }}
  >
    Últ. modificación (reciente)
  </option>

  <option
    value="creacion_desc"
    style={{ background: "#0f172a", color: "white" }}
  >
    Fecha creación (reciente)
  </option>

  <option
    value="creacion_asc"
    style={{ background: "#0f172a", color: "white" }}
  >
    Fecha creación (antigua)
  </option>
</select>



  {/* Limpiar filtros */}
  <button
    style={{
      ...filterBtn,
      background: "rgba(239,68,68,0.15)",
      border: "1px solid rgba(239,68,68,0.45)",
      color: "#fecaca"
    }}
    onClick={() =>
      setFiltros({ ciudad: "", estado: "", llamadasPendientes: false })
    }
  >
   Limpiar
  </button>
</div>




      {/* NUEVA VISITA (inline, como SAT “Agregar incidencia”) */}
      {mostrarNuevaVisita && (
        <div style={card}>
          <div style={{ fontWeight: 800, marginBottom: 10 }}>
            Nueva visita (rellenar rápido)
          </div>

          <div style={formGrid}>
            <Input
              label="Nombre comercial"
              value={formNueva.comercial}
              onChange={(v) => setFormNueva({ ...formNueva, comercial: v })}
            />
            <Input
              label="Nombre contacto"
              value={formNueva.contacto}
              onChange={(v) => setFormNueva({ ...formNueva, contacto: v })}
            />
            
            <Input
              label="Teléfono"
              value={formNueva.telefono}
              onChange={(v) => setFormNueva({ ...formNueva, telefono: v })}
            />

            <Input
  label="Email"
  value={formNueva.email}
  onChange={(v) => setFormNueva({ ...formNueva, email: v })}
/>

            <Input
              label="Ciudad"
              value={formNueva.ciudad}
              onChange={(v) => setFormNueva({ ...formNueva, ciudad: v })}
            />
            <Input
              label="Dirección"
              value={formNueva.direccion}
              onChange={(v) => setFormNueva({ ...formNueva, direccion: v })}
            />
          </div>

          <div style={{ display: "flex", gap: 10, marginTop: 12 }}>
            <button style={btnPrimary} onClick={onGuardarNuevaVisita}>
              Guardar visita
            </button>
            <button
              style={btnSecondary}
              onClick={() => setMostrarNuevaVisita(false)}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* LISTADO TIPO SAT */}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {visitasFiltradas.map((v) => {

          const pendiente = tieneLlamadaPendiente(v);
          const abierto = !!expanded[v.id];

          return (
            <div
              key={v.id}
              style={{
                ...bloqueBase,
                border: pendiente
                  ? "1px solid rgba(239,68,68,0.55)"
                  : "1px solid rgba(148,163,184,0.28)",
                background: pendiente
                  ? "linear-gradient(180deg, rgba(239,68,68,0.13), rgba(15,23,42,0.78))"
                  : "rgba(15,23,42,0.78)"
              }}
            >
              {/* CABECERA BLOQUE */}
              <div style={bloqueHeader}>
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                    <div style={{ fontWeight: 900, fontSize: 16 }}>
                      {v.contacto || "Sin contacto"}
                    </div>

                    <span style={{ ...pill, ...estadoPill[v.estado] }}>
  {estadoLabel[v.estado]}
</span>


                    {pendiente && (
                      <span style={{ ...pill, borderColor: "rgba(239,68,68,0.7)" }}>
                        📞 Llamada pendiente
                      </span>
                    )}
                  </div>

                  <div style={sub}>
                    Comercial: <strong>{v.comercial || "-"}</strong> · Tel:{" "}
                    <strong>{v.telefono || "-"}</strong> · {v.ciudad || "-"}
                  </div>

                  <div style={sub}>
                    Dirección: {v.direccion || "-"} · Últ. modif.:{" "}
                    {v.ultimaModificacion || "-"}
                  </div>
                </div>

{/* ACCIONES CABECERA */}
<div style={{ display: "flex", gap: 8, alignItems: "center" }}>
  <button
    style={btnSmall}
    onClick={() => {
      setFormNueva({
        comercial: v.comercial || "",
        contacto: v.contacto || "",
        telefono: v.telefono || "",
        email: v.email || "",
        direccion: v.direccion || "",
        ciudad: v.ciudad || ""
      });
      setEditandoId(v.id);
      setMostrarNuevaVisita(true);
    }}
  >
    ✏️ Editar
  </button>

  <button style={btnSmall} onClick={() => onToggleExpanded(v.id)}>
    {abierto ? "▾ Contraer" : "▸ Ampliar"}
  </button>
</div>
</div>


                            <div style={{ display: "flex", gap: 8, marginTop: 8 }}>
                <button
                  style={btnSmall}
                  onClick={() => setEstadoVisita(v.id, "interesado")}
                >
                  👍 Interesado
                </button>

                <button
                  style={btnSmall}
                  onClick={() => setEstadoVisita(v.id, "no_interesado")}
                >
                  👎 No interesado
                </button>

                <button
                  style={btnSmall}
                  onClick={() => setEstadoVisita(v.id, "vendido")}
                >
                  🟢 Vendido
                </button>
              </div>

              {!abierto && v.presupuestos && v.presupuestos.length > 0 && (
  <div style={{ fontSize: 12, opacity: 0.7, marginTop: 4 }}>
    📄 {v.presupuestos.map(p => p.numero).join(", ")}
  </div>
)}




              {/* CONTENIDO EXPANDIBLE */}
              {abierto && (
                <div style={{ marginTop: 10 }}>
                  {/* LISTA OBSERVACIONES */}
                  <div style={{ fontWeight: 800, marginBottom: 8 }}>
                    Observaciones
                  </div>

                  {(v.observaciones || []).length === 0 ? (
                    <div style={{ ...sub, marginBottom: 10, opacity: 0.75 }}>
                      No hay observaciones todavía.
                    </div>
                  ) : (
                    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                      {v.observaciones.map((o, idx) => (
                        <div
                          key={idx}
                          style={{
                            ...obsRow,
                            borderLeft: o.requiereLlamada
                              ? "4px solid rgba(34,197,94,0.9)"
                              : "4px solid rgba(59,130,246,0.9)"
                          }}
                        >
                          <div style={{ fontWeight: 800 }}>
                            {o.requiereLlamada ? "📞 " : "📝 "}
                            {o.texto}
                          </div>
                          <div style={sub}>
                            {o.fecha || "—"} {o.hora || ""}{" "}
                            {o.requiereLlamada ? "· requiere llamada" : ""}
                          </div>

                          {o.requiereLlamada && (
                            <div style={{ marginTop: 8 }}>
                              <button
                                style={btnSmall}
                                onClick={() => onMarcarLlamadaHecha(v.id, idx)}
                              >
                                Marcar llamada hecha
                              </button>
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  )}

                  

{/* =====================
    PRESUPUESTOS
===================== */}
<div style={{ marginTop: 20 }}>
  <div style={{ fontWeight: 800, marginBottom: 8 }}>
    Presupuestos
  </div>

  {(!v.presupuestos || v.presupuestos.length === 0) ? (
    <div style={{ ...sub, opacity: 0.7 }}>
      No hay presupuestos asociados.
    </div>
  ) : (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      {v.presupuestos.map((p) => (
        <div
          key={p.id}
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 12px",
            borderRadius: 12,
            border: "1px solid rgba(148,163,184,0.25)",
            background: "rgba(255,255,255,0.06)",
            color: "white"
          }}
        >
          {/* INFO */}
          <div>
            <strong>{p.numero}</strong>
            <div style={sub}>{p.fecha}</div>
          </div>

          {/* ENVÍO + ACCIONES */}
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>


            {/* FECHA ENVÍO */}
            {p.email_enviado_at && (
              <span
                title={`Enviado el ${formatFechaHora(p.email_enviado_at)}`}
                style={{ fontSize: 12, opacity: 0.7, whiteSpace: "nowrap" }}
              >
                ✉️ {formatFechaHora(p.email_enviado_at)}
              </span>
            )}

            {/* BOTONES */}
            <div style={{ display: "flex", gap: 6 }}>
              {/* PDF */}
              <button
                style={btnSmall}
                title="Ver PDF"
                onClick={() =>
                  window.open(`/api/presupuestos/${p.id}/pdf`, "_blank")
                }
              >
                📄
              </button>

              {/* EMAIL */}
              <button
                style={{
                  ...btnSmall,
                  opacity: p.email_enviado_at ? 0.8 : 1
                }}
                title={
                  p.email_enviado_at
                    ? `Enviado el ${formatFechaHora(p.email_enviado_at)}`
                    : "Enviar por correo"
                }
                onClick={() => {
                  setEmailData({
                    id: p.id,
                    numero: p.numero,
                    email: v.email
                  });
                  setOpenEmail(true);
                }}
              >
                ✉️
              </button>

              {/* BORRAR */}
              <button
                style={{ ...btnSmall, background: "rgba(239,68,68,0.2)" }}
                title="Borrar presupuesto"
                onClick={async () => {
                  if (!window.confirm(`¿Borrar el presupuesto ${p.numero}?`)) return;
                  await axios.delete(`/crm/${v.id}/presupuestos/${p.id}`);

                  await cargarCRM();
                }}
              >
                🗑️
              </button>
            </div>
          </div>
        </div>
      ))}
    </div>
  )}
</div>


                  {/* FORM OBSERVACIÓN INLINE */}
                  <div style={{ marginTop: 12, ...divider }} />

                  <div style={{ fontWeight: 800, marginBottom: 8 }}>
                    Añadir observación
                  </div>

                  <div style={formObsGrid}>
                    <div style={{ gridColumn: "1 / -1" }}>
                      <div style={labelStyle}>Observación</div>
                      <textarea
                        value={obsDraft[v.id]?.texto || ""}
                        onChange={(e) =>
                          onChangeObsDraft(v.id, { texto: e.target.value })
                        }
                        style={textarea}
                        rows={2}
                        placeholder="Escribe la nota o la llamada pendiente…"
                      />
                    </div>

                    <Input
                      type="date"
                      label="Fecha"
                      value={obsDraft[v.id]?.fecha || ""}
                      onChange={(val) => onChangeObsDraft(v.id, { fecha: val })}
                    />

                    <Input
                      type="time"
                      label="Hora"
                      value={obsDraft[v.id]?.hora || ""}
                      onChange={(val) => onChangeObsDraft(v.id, { hora: val })}
                    />

                    <div style={{ display: "flex", alignItems: "end" }}>
                      <label style={{ fontSize: 13, display: "flex", gap: 8, alignItems: "center" }}>
                        <input
                          type="checkbox"
                          checked={!!obsDraft[v.id]?.requiereLlamada}
                          onChange={(e) =>
                            onChangeObsDraft(v.id, {
                              requiereLlamada: e.target.checked
                            })
                          }
                        />
                        Requiere llamada
                      </label>
                    </div>
                  </div>

                  <div style={{ display: "flex", gap: 10, marginTop: 10 }}>
                    <button style={btnPrimary} onClick={() => onAddObservacion(v.id)}>
                      Guardar observación
                    </button>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* ===== MODAL ENVÍO EMAIL PRESUPUESTO ===== */}
      {openEmail && emailData && (
        <EmailPresupuestoModal
          isOpen={openEmail}
          onClose={() => setOpenEmail(false)}
          presupuesto={{
            id: emailData.id,
            numero: emailData.numero,
            email: emailData.email
          }}
          onSend={async (data) => {
            await axios.post(
              `/presupuestos/${emailData.id}/send-email`,
              data
            );
            setOpenEmail(false);
            await cargarCRM();
          }}
        />
      )}




    </div>
  );
}



/* ============================
   INPUT
============================ */
function Input({ label, value, onChange, type = "text" }) {
  return (
    <div>
      <div style={labelStyle}>{label}</div>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={input}
      />
    </div>
  );
}


/* ============================
   ESTILOS
============================ */
const page = {
  padding: 20,
  minHeight: "100vh",
  background:
    "radial-gradient(circle at top left, #1f2937, #020617 60%, #000000)",
  color: "white"
};

const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16
};

const title = { margin: 0, fontSize: 22, fontWeight: 800 };
const subtitle = { marginTop: 6, fontSize: 13, opacity: 0.75 };

const formGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  gap: 12
};

const formObsGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  gap: 12
};

const labelStyle = { fontSize: 12, opacity: 0.7, marginBottom: 4 };

const input = {
  width: "100%",
  padding: "8px 10px",
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.22)",
  background: "rgba(255,255,255,0.08)",
  color: "white",
  outline: "none"
};

const textarea = {
  width: "100%",
  padding: "8px 10px",
  borderRadius: 10,
  border: "1px solid rgba(255,255,255,0.22)",
  background: "rgba(255,255,255,0.08)",
  color: "white",
  outline: "none",
  resize: "vertical"
};

const card = {
  background: "rgba(15,23,42,0.78)",
  borderRadius: 14,
  border: "1px solid rgba(148,163,184,0.30)",
  backdropFilter: "blur(10px)",
  boxShadow: "0 10px 25px rgba(0,0,0,0.45)",
  padding: 14,
  marginBottom: 14
};

const bloqueBase = {
  borderRadius: 16,
  padding: 14,
  backdropFilter: "blur(10px)",
  boxShadow: "0 10px 25px rgba(0,0,0,0.45)"
};

const bloqueHeader = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: 16
};

const sub = { fontSize: 12, opacity: 0.75, marginTop: 4 };

const pill = {
  fontSize: 12,
  fontWeight: 800,
  padding: "4px 10px",
  borderRadius: 999,
  border: "1px solid rgba(255,255,255,0.22)",
  background: "rgba(255,255,255,0.08)"
};

const obsRow = {
  padding: 12,
  borderRadius: 12,
  background: "rgba(255,255,255,0.06)",
  border: "1px solid rgba(148,163,184,0.22)"
};

const divider = {
  borderTop: "1px solid rgba(148,163,184,0.20)"
};

const btnBase = {
  borderRadius: 12,
  padding: "9px 14px",
  fontSize: 13,
  fontWeight: 800,
  border: "1px solid rgba(255,255,255,0.22)"
};

const btnPrimary = {
  ...btnBase,
  background: "#3b82f6",
  color: "white",
  cursor: "pointer"
};

const btnSecondary = {
  ...btnBase,
  background: "rgba(255,255,255,0.12)",
  color: "white",
  cursor: "pointer"
};

const btnDisabled = {
  ...btnBase,
  background: "rgba(255,255,255,0.10)",
  color: "rgba(255,255,255,0.6)",
  cursor: "not-allowed"
};

const btnLink = {
  ...btnBase,
  background: "rgba(255,255,255,0.12)",
  color: "white",
  textDecoration: "none",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
};

const btnSmall = {
  ...btnBase,
  padding: "6px 10px",
  fontSize: 12,
  background: "rgba(255,255,255,0.10)",
  color: "white",
  cursor: "pointer"
};

const estadoLabel = {
  visitado: "🔵 Visitado",
  interesado: "🟡 Interesado",
  no_interesado: "⚫ No interesado",
  vendido: "🟢 Vendido"
};



const estadoPill = {
  visitado: {},
  interesado: { borderColor: "#eab308", color: "#fde68a" },
  no_interesado: { borderColor: "#6b7280", color: "#d1d5db" },
  vendido: { borderColor: "#22c55e", color: "#bbf7d0" }
};

const filterBar = {
  display: "flex",
  alignItems: "center",
  gap: 10,
  marginBottom: 12,
  padding: "6px 10px",
  background: "rgba(255,255,255,0.04)",
  borderRadius: 8
};

const filterSelectSmall = {
  height: 32,
  padding: "0 10px",
  fontSize: 13,
  background: "rgba(255,255,255,0.06)",
  color: "white",
  border: "1px solid rgba(255,255,255,0.2)",
  borderRadius: 6,
  minWidth: 160
};

const filterCheck = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  fontSize: 13,
  whiteSpace: "nowrap"
};

const filterBtn = {
  height: 32,
  padding: "0 10px",
  fontSize: 13
};
